import { ExcessMoneySettlementReducerDispatch, ExcessMoneySettlementRedux, ExcessMoneySettlementReduxState, ExcessMoneySettlementTypes } from "./types"

const FETCH_EXCESS_MONEY_SETTLEMENT_LIST_INIT_STATE = {
    data: {
        metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
                self: null,
                first: null,
                previous: null,
                next: null,
                last: null
            }
        },
        records: []
    },
    loading: false,
    error: null
}

const ExcessMoneySettlementListReducer = (state: ExcessMoneySettlementReduxState = FETCH_EXCESS_MONEY_SETTLEMENT_LIST_INIT_STATE, action: ExcessMoneySettlementReducerDispatch) => {
    switch (action.type) {
        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS: {
            return {
                ...state,
                loading: true
            }
        }

        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }

        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENTS_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        case ExcessMoneySettlementTypes.RESET: {
            return {
                ...state,
                data: {
                    metadata: {
                        totalCount: 0,
                        currentPageRecords: 0,
                        totalPages: 0,
                        links: {
                            self: null,
                            first: null,
                            previous: null,
                            next: null,
                            last: null
                        }
                    },
                    records: []
                },
                loading: false,
                error: false
            }
        }
        default:
            return { ...state };
    }
}

const FETCH_EXCESS_MONEY_SETTLEMENT_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}

const ExcessMoneySettlementReducer = (state: ExcessMoneySettlementRedux = FETCH_EXCESS_MONEY_SETTLEMENT_INIT_STATE, action: ExcessMoneySettlementReducerDispatch) => {
    switch (action.type) {
        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT: {
            return {
                ...state,
                loading: true
            }
        }

        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }

        case ExcessMoneySettlementTypes.FETCH_EXCESS_MONEY_SETTLEMENT_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }

        case ExcessMoneySettlementTypes.RESET: {     
            return {
                ...state,
                data: {},
                loading: false,
                error: false
            }
        }
        default:
            return { ...state };
    }
}

export { ExcessMoneySettlementListReducer, ExcessMoneySettlementReducer };